import { useEffect, useState } from "react";

const LoadingScreen = () => {
  const [hidden, setHidden] = useState(false);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    // Trigger exit animation after wave sweep (~2.6s + 0.6s exit)
    const exitTimer = setTimeout(() => setExiting(true), 2600);
    const removeTimer = setTimeout(() => setHidden(true), 3400);
    return () => {
      clearTimeout(exitTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (hidden) return null;

  return (
    <div
      className={`loka-preloader ${exiting ? "loka-preloader-exit" : ""}`}
      data-testid="loading-screen"
    >
      <div className="loka-preloader-logo">
        LOKA BEDS
        <span className="loka-preloader-dot" />
      </div>
      <div className="loka-wave-sweep" />
    </div>
  );
};

export default LoadingScreen;
